module.exports = __webpack_public_path__ + "img/ics_o_edit_plus.046eab89.svg";